import { DemoScenarioForm } from "@/components/demo/DemoScenarioForm";
import { DemoScenarioTable } from "@/components/demo/DemoScenarioTable";

export default function DemoManagement() {
  return (
    <div className="container mx-auto py-6 space-y-8">
      <h1 className="text-2xl font-bold">Manage Demo Scenarios</h1>

      <div className="space-y-8">
        <section>
          <h2 className="text-lg font-semibold mb-4">Create New Demo Scenario</h2>
          <DemoScenarioForm />
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-4">Existing Demo Scenarios</h2>
          <DemoScenarioTable />
        </section>
      </div>
    </div>
  );
}
